import * as React from "react";

const ArrowRight = ( {style} ) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6"
    height="10"
    fill="none"
    viewBox="0 0 6 10"
    className="arrow-transition"
    style={style}
    >
    <path
      id="arrowRight"
      fill="rgba(181, 181, 170, 1)"
      d="M0 9.25c0 .67.867 1.002 1.37.526L5.71 5.66a.9.9 0 0 0 0-1.322L1.37.224C.867-.252 0 .08 0 .75z"
    ></path>
  </svg>
);

export default ArrowRight;


